export default "__VITE_ASSET__sAJrOOed__"